import man from './images/man.svg'

const images = {
  man,
}

export default images
